import React from "react";
import { format } from "date-fns";

const EventCard = ({ event, handleSeeMore, MAX_LENGTH, onClick }) => {
  return (
    <div
      className="flex flex-col h-full relative group cursor-pointer"
      onClick={onClick}
    >
      <div className="flex-1">
        <div className="rounded-3xl overflow-hidden shadow-xl bg-white flex flex-col h-full group transition-all duration-500 hover:scale-105 hover:-translate-y-2 hover:shadow-2xl">
          <div className="relative">
            <img
              src={event.imageUrl}
              alt={event.title}
              onError={(e) => {
                e.currentTarget.onerror = null;
              }}
              className="w-full h-56 object-cover border-2 border-transparent group-hover:border-blue-600 transition-all duration-300"
            />
            {event.dateObj && (
              <div className="absolute top-4 left-4 w-16 h-16 bg-amber-600 text-white rounded-lg flex flex-col items-center justify-center text-center shadow-lg z-10">
                <span className="text-xs">
                  {format(new Date(event.dateObj), "MMM")}
                </span>
                <span className="text-xl font-bold">
                  {format(new Date(event.dateObj), "dd")}
                </span>
              </div>
            )}
          </div>
          <div className="p-6 flex flex-col flex-1">
            <h3 className="text-2xl font-bold text-black mb-2 line-clamp-2 font-manrope">
              {event.title}
            </h3>

            {event.location && (
              <p className="text-sm text-gray-500 mb-2">📍 {event.location}</p>
            )}

            <p className="text-gray-600 text-base mb-4">
              {event.description && event.description.length > MAX_LENGTH ? (
                <>
                  {event.description.slice(0, MAX_LENGTH)}...{" "}
                  <button
                    className="text-primary-600 hover:underline font-semibold"
                    onClick={() => handleSeeMore(event)}
                  >
                    See More
                  </button>
                </>
              ) : (
                event.description
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
